import { Trash2 } from "lucide-react";
import { useTran } from "@/hooks";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

/**
 * MetricCardAnnualInput - Annual target input with delete button
 */
const MetricCardAnnualInput = ({
  selectedYear,
  target,
  disclosure,
  baseline,
  onAnnualChange,
  onDelete,
}) => {
  const { t } = useTran();

  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-foreground">
        {t("Annual Target")} ({selectedYear})
      </label>
      <div className="flex flex-wrap items-center gap-2">
        <Input
          type="number"
          value={target?.annual || ""}
          onChange={onAnnualChange}
          placeholder={t("e.g. {{value}}", { value: baseline })}
          className="flex-1"
        />
        <span className="text-sm text-muted-foreground">
          {disclosure.unit || ""}
        </span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="text-destructive hover:text-destructive"
          onClick={onDelete}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default MetricCardAnnualInput;
